import SectionHeading from "./SectionHeading";
import { ninetiesTimeline } from "@/mocks/nineties";

export default function NinetiesTimeline() {
  return (
    <section id="nineties" className="scroll-mt-20 bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="1990 - 1999"
          title="九十年代电影年表"
          desc="按年份梳理九十年代的电影脉络，每一年标出题材走向与代表作品，方便系统回顾这一时期的变化。"
        />

        <ol className="mt-10 md:mt-14 relative">
          <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300" />
          {ninetiesTimeline.map((item) => (
            <li key={item.year} className="relative pl-8 md:pl-10 pb-8 last:pb-0">
              <span className="absolute left-0 top-1.5 w-4 h-4 rounded-full bg-accent-500 ring-4 ring-background-50" />
              <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-primary-600">
                    {item.year}
                  </span>
                  <span className="h-4 w-px bg-background-300 hidden sm:block" />
                  <span className="text-sm md:text-base font-medium text-foreground-900">
                    {item.topic}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {item.note}
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {item.films.map((film) => (
                    <span
                      key={film}
                      className="px-2.5 py-1 rounded-full bg-background-50 border border-background-200 text-xs font-label text-foreground-700"
                    >
                      {film}
                    </span>
                  ))}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}